import { Cookie } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { useCookieConsent } from '@/contexts/CookieConsentContext'

export const CookieSettingsButton = () => {
  const { hasUserMadeChoice, setShowSettings } = useCookieConsent()

  // Only show the button after user has made a choice
  if (!hasUserMadeChoice) {
    return null
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="secondary"
              size="icon"
              className="h-12 w-12 rounded-full shadow-lg border-2 bg-background/90 backdrop-blur-sm hover:bg-accent/90 transition-all duration-300 hover:scale-105"
              onClick={() => setShowSettings(true)}
              aria-label="Cookie-Einstellungen öffnen"
            >
              <Cookie className="h-5 w-5" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="left" className="max-w-xs">
            <p>Cookie-Einstellungen verwalten</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}